/**
 * /tenants/$slug/directory/matching — the Matching tab of People → Connections.
 *
 * The uniqueness rules a pushed record is judged against (employee number,
 * primary email) belong with the sources that push, not in Settings
 *. The old Settings path redirects here.
 */

import { createFileRoute } from "@tanstack/react-router";
import { Breadcrumbs, PageHeader } from "@pureid/ui";

import { ConnectionsTabs } from "@/features/directory/components/connections-tabs";
import { IdentityMatchingSettingsPage } from "@/features/tenant-settings/pages/identity-matching-settings-page";

function MatchingPage() {
  const { tenant } = Route.useRouteContext();
  return (
    <div className="space-y-6">
      <Breadcrumbs
        items={[
          { label: "Tenants", href: "/tenants" },
          { label: tenant.name, href: `/tenants/${tenant.slug}` },
          { label: "People" },
          { label: "Connections", href: `/tenants/${tenant.slug}/directory` },
          { label: "Matching" },
        ]}
      />
      <PageHeader
        title="Connections"
        description={`The upstream systems that feed ${tenant.name}: who signs people in, and who pushes their records.`}
      />
      <ConnectionsTabs tenantSlug={tenant.slug} />
      <IdentityMatchingSettingsPage />
    </div>
  );
}

export const Route = createFileRoute("/_authed/tenants/$slug/directory/matching")({
  component: MatchingPage,
});
